import { AssessmentResultRecordType } from "../types";

export default function getStudentEmail(
  assessment: AssessmentResultRecordType
) {
  return assessment.student.email || "no email available";
}
